import React, 
{ 
    useEffect,
    useState 
} from 'react'

import toast from 'react-hot-toast';
import dayjs from 'dayjs';

import { 
    Delete,
    Edit,
} from '@mui/icons-material';

import { 
    Form,
    Input,
    Col, 
    Row,
    Table,
    Space,
    Button,
    DatePicker,
} from 'antd';

import { usePostRequest } from '../../hooks/usePostRequest'

const BillingAdmissionFee = ({admissionData, fetchMembersData, isLoading, id}) => {
    // const navigate = useNavigate() 
    const { callPost, loading } = usePostRequest(()=>{
        fetchMembersData();
    });
    const [admissionInfo, setAdmissionInfo] = useState([])

    const handleDelete = (key) => {
        const newData = [...admissionInfo];
        newData.splice(key, 1); 
        setAdmissionInfo(() => newData)
    };
      
    const addRow = () => {
        const newData = [...admissionInfo];
        newData.push({
            adfee_ors: '',
            adfee_dates: undefined,
            adfee_amounts: '',
            isWritable: true,
        });
        setAdmissionInfo(newData);
    };

    const handleTable = (e, index, name, isDate) => {
        if(isDate){
            setAdmissionInfo(prevState => {
                const newState = [...prevState];
                newState[index] = { 
                    ...newState[index],
                    [name]: e
                };
                return newState;
            });
        } else {
            const { value } = e.target

            setAdmissionInfo(prevState => {
            const newState = [...prevState];
            newState[index] = { 
                ...newState[index],
                [name]: value
            };
            return newState;
            });
        }
    }

    const handleRowClick = (row_id) => {
        const newData = admissionInfo?.map((item, index) => ({
          ...item,
          isWritable: row_id === index ? !item.isWritable : item.isWritable,
        }));
        setAdmissionInfo(newData);
    };

    const defaultColumns = [
        {
            title: 'OR',
            dataIndex: 'adfee_ors',
            align: 'center',
            key: 'adfee_ors',
            render: (_, record, index) => (
            record.isWritable ? (
                
                <Input
                    value={record.adfee_ors}
                    onChange={(e) => handleTable(e, index, "adfee_ors")}
                />
            ) : record.adfee_ors
          ),
        },
        {
            title: 'Date',
            dataIndex: 'adfee_dates',
            align: 'center',
            key: 'adfee_dates',
            render: (_, record, index) => (
            record.isWritable ? (
                <DatePicker        
                    style={{width:'100%'}}
                    value={record.adfee_dates}
                    onChange={(e) => handleTable(e, index, "adfee_dates", true)}
                />
            ) : record.adfee_dates?.format('MMMM D, YYYY')
          ),
        },
        {
            title: 'Amount',
            dataIndex: 'adfee_amounts',
            align: 'center',
            key: 'adfee_amounts',
            render: (_, record, index) => (
            record.isWritable ? (
                <Input
                    value={record.adfee_amounts}
                    onChange={(e) => handleTable(e, index, "adfee_amounts")}
                />
            ) : record.adfee_amounts
          ),
        },
        {
            title: '',
            dataIndex: '',
            align: 'center',
            render: (_, record, index) => (
                <Space>
                    {
                        (record.id) && (
                            <div 
                                onClick={() => handleRowClick(index)}
                                className='cursor'
                            >
                                <Edit/>
                            </div>
                        )
                    }
                    <div 
                        onClick={() => handleDelete(index)}
                        className='cursor'
                    >
                        <Delete  
                            style={{
                                color: 'red',
                            }}
                        />
                    </div>
                </Space>
            ),
            onCell: () => ({
                onClick: (e) => {
                e.stopPropagation();
                },
            }),
        },
    ];
    const handleCreateAdmission = () => {
        try {
            const newValues = {
                member_id: id,
                id: [],
                adfee_ors: [],
                adfee_dates: [],
                adfee_amounts: [],
            }

            admissionInfo?.forEach(item => {
                newValues.id.push(item.id || "");
                newValues.adfee_ors.push(item.adfee_ors || "");
                newValues.adfee_amounts.push(item.adfee_amounts || "");
                newValues.adfee_dates.push(item.adfee_dates ? item.adfee_dates.format("YYYY-MM-DD") : "");
            });

            callPost(
                "members/update_admission_fee", 
                newValues,
                false,
            );
        } catch(errorInfo)  {
            toast.error('Validation Failed ', errorInfo);
        };
    };
    console.log(admissionInfo)
    const validateArray = (array) => {
        return array.every((item) => {
            return item.adfee_ors !== "" || item.adfee_dates !== undefined || item.adfee_amounts !== "" ;
        });
    };  

    useEffect(() => {
        if(admissionData){
            const admission_data = admissionData?.map((data) => ({
                id: data.id,
                member_id: data.member_id,
                adfee_ors: data.or,
                adfee_dates: data.date ? dayjs(data.date) : undefined,
                adfee_amounts: data.amount,
                added_by: data.added_by,
                added_on: data.added_on,
                updated_by: data.updated_by,
                updated_on: data.updated_on,
                is_deleted: data.is_deleted,
            }))
             
            setAdmissionInfo(admission_data)
        }
    }, [admissionData])

    return (
        <Row className='tab-container custom-padding'>
            <Col span={24}>
                <Form 
                    layout="vertical"
                >
                    <Row>
                        <Col span={24} className='responsive-overflow-y'>
                            <Table
                                bordered
                                dataSource={admissionInfo}
                                columns={defaultColumns}
                                pagination={false}
                                loading={isLoading}
                                scroll={{ x: 800 }} 
                            />
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]} className='responsive-inline responsive-width mt-4' >
                        <Col span={24}>
                            <Button 
                                type="primary" 
                                onClick={addRow}
                            >
                                Add Row
                            </Button>
                        </Col>
                    </Row>
                    <Row className='btn-footer'>
                        <Space className='p-2'>
                            <Button
                                onClick={handleCreateAdmission}
                                loading={loading}
                                type='primary'
                                disabled={!validateArray(admissionInfo)}
                                className='button-color btn-header'
                            >
                                Save
                            </Button>
                        </Space>
                    </Row>
                </Form>
            </Col>
        </Row>
    )
}
export default BillingAdmissionFee
